interface IsValidNumberOptions {
  isEmptyStringValid?: boolean;
  isRequiredToBeInteger?: boolean;
  isRequiredToBeGreaterThanOrEqualToZero?: boolean;
  isRequiredToBeGreaterThanZero?: boolean;
}

export function isValidNumber(number: number | string, options: IsValidNumberOptions = {}) {
  let { isEmptyStringValid, isRequiredToBeInteger, isRequiredToBeGreaterThanOrEqualToZero, isRequiredToBeGreaterThanZero } = options;

  if (typeof number !== 'string' && typeof number !== 'number') {
    return false;
  }

  if (typeof isEmptyStringValid !== 'boolean') {
    isEmptyStringValid = false;
  }

  if (typeof isRequiredToBeInteger !== 'boolean') {
    isRequiredToBeInteger = false;
  }

  if (typeof isRequiredToBeGreaterThanOrEqualToZero !== 'boolean') {
    isRequiredToBeGreaterThanOrEqualToZero = false;
  }

  if (typeof isRequiredToBeGreaterThanZero !== 'boolean') {
    isRequiredToBeGreaterThanZero = false;
  }

  if (typeof number === 'string') {
    number = number.trim();
  }

  if (number === '') {
    return isEmptyStringValid;
  }

  number = Number(number);

  if (isNaN(number)) {
    return false;
  }

  if (isRequiredToBeInteger && Math.round(number) !== number) {
    return false;
  }

  if (isRequiredToBeGreaterThanOrEqualToZero && number < 0) {
    return false;
  }

  return !isRequiredToBeGreaterThanZero || number > 0;
}
